<template >
    <b-card>
        <h3>Guias de corte</h3>
        <b-row>
            <b-button  v-for="item in listSku" :key="item.sku" :variant="item.variant" class="btn-options" :class="{ 'option-select': item.sku === skuSelect}" @click="cambioSku(item)" >{{item.titulo}}: <b>{{item.cantidad}}</b></b-button>
        </b-row>        
        <!--<h4>Cantidad: <b>{{cantidadActual}}</b></h4>-->
        <h4>Color</h4>
        <b-row>
            <b-button  v-for="item in coloresSku" :key="item.name" :variant="item.variant" class="btn-options" :class="{ 'option-select': item.nombre === colorSelect}" @click="cambioColor(item.nombre)">{{item.nombre}}: {{item.cantidad}}</b-button>
        </b-row>        
        <h4>Trabajo</h4>
        <b-row>
            <b-button :variant="pielButton" class="btn-options" :class="{ 'option-select': categoriaActiva === 'Piel' }" @click="cambioCategoria('Piel')">Piel</b-button>
            <b-button :variant="forrosButton" class="btn-options" :class="{ 'option-select': categoriaActiva === 'Forros' }" @click="cambioCategoria('Forros')">Forros</b-button>
            <b-button :variant="refuerzosButton" class="btn-options" :class="{ 'option-select': categoriaActiva === 'Refuerzos' }" @click="cambioCategoria('Refuerzos')">Refuerzos</b-button>
            <b-button variant="outline-danger" class="btn-options ml-auto" @click="reportModal(null)">Reportar {{tituloSelect}}</b-button>
        </b-row>
        <!--<div class="table-responsive">-->

        <b-table
            :items="piezas"
            :fields="columnasTable"
            class="table table-borderless table-prevision"
            no-border-collapse
            sort-icon-left
            striped 
            ref="tableCorte"
            >
            <template #cell(fabricar)="data">
               <div v-if="data.item.terminadoTotal>0 && data.item.fabricar != data.item.terminadoTotal">
                  <span style="text-decoration:line-through; margin-right: 10px">{{data.item.fabricar}}</span> 
                  <span>{{data.item.terminadoTotal}}</span>
              </div>
              <span v-else >{{data.item.fabricar}}</span>
            </template>

            <template #cell(img)="data">
                <div style="position: relative; display: flex; justify-content: center; align-items: center; padding: 10px" @click="piezaFinalizada(data.item)">
                    <div :class="{'div-imagenes': data.item.finalizado,'div-imagenes-incompleta': data.item.terminadoTotal !== data.item.fabricar && data.item.terminadoTotal > 0 } " style=" position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></div>
                    <img :src="data.item.img" style="max-width: 100px;" alt="">
                </div>
            </template>
            <template #cell(options)="data">
              <div style="text-align: center" @click="reportModal(data.item)">
                <i class="fa-solid fa-triangle-exclamation" style="font-size: 30px; color: lightgray"></i>
              </div>
            </template>
        </b-table>
        <!--</div>-->

        <b-modal
            id="modal-report"
            ref="modal-report"
            ok-only
            ok-title="Accept"
            centered
            hide-footer
            size="LG"
            :title="'Reportar problema con ' + piezaReport.troquel "
        >

        <b-row class="match-height" v-if="reportTipo == 0">
          <b-col cols="6">
            <div class="div-reporte" @click="seleccionarTipoReport(1)">
              Reporte
            </div>

          </b-col>
          <b-col cols="6">
            <div class="div-reporte" @click="seleccionarTipoReport(2)">
              Cambiar Stock
            </div>

          </b-col>
        </b-row>

          <b-row class="match-height" v-if="reportTipo != 0">
              <b-col cols="12">
                  <b-row class="match-height">
                  <!--categoria-->
                  <!--Descripcion-->
                    <b-col cols="12">

                        <b-form-textarea
                            id="descripcionReportInput"
                            ref="descripcionReportInput"
                            placeholder="Descripcion"
                            rows="4"
                            v-model="descripcionReport"
                          />
                    </b-col>
                  </b-row>
                  <b-row class="match-height" style="margin-top: 10px" v-if="reportTipo == 2">
                  <!--Descripcion-->
                    <b-col cols="6">

                        <label for="sb-disabled">Cantidad a cortar</label>
                        <b-form-spinbutton
                          class="spinDisable"
                          id="sb-disabled"
                          v-model="cantidadObjetivo"
                          disabled
                        />
                    </b-col>
                    <b-col cols="6">
 
                       <label for="sping-cortado">Cantidad cortada</label>
                        <b-form-spinbutton
                          id="sping-cortado"
                          v-model="cantidadCortada"
                          
                        />
                    </b-col>
                  </b-row>
                  <br>
                  <b-button variant="outline-primary" @click="guardarReporte()">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    <span class="align-middle"> Crear reporte</span>
                  </b-button>

              </b-col>

          </b-row>

        </b-modal>

    </b-card>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable, BFormInput, BFormGroup, BRow, BCol} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'

  export default {
    components: {
        BCardCode,
        BTable,
        BFormInput,
        BFormGroup,
        BRow,
        BCol,
        vSelect,
    },
    data () {
      return {
        columnasTable: [
        {
          key: "troquel",
          label: "Ref",
          sortable: true,
          thStyle: { width: "5%" },
        },{
          key: "cantidad",
          label: "Ud",
          sortable: true,
        },{
          key: "categoria",
          label: "Materia",
          sortable: true,
        },{
          key: "color",
          label: "Color",
          sortable: true,
        },{
          key: "fabricar",
          label: "Pedido",
          sortable: true,
        },{
          key: "descripcion",
          label: "Descripcion",
          sortable: true,
        },{
          key: "img",
          label: "Pieza",
          sortable: true,
        },{
          key: "options",
          label: "Reportes",
          thStyle: { width: "5%" },
        }],
        piezas: [],
        allPiezas: [],
        categoriaActiva: "Piel",
        pielButton: "primary",
        forrosButton: "outline-dark",
        refuerzosButton: "outline-dark",
        coloresSku: [],
        colorSelect: null,
        listSku: [],
        skuSelect: null,
        skuCorte: [],
        cantidadActual: 0,
        tituloSelect: "",
        piezaReport: {troquel: ""},
        descripcionReport: "",
        reportTipo: 0,
        cantidadObjetivo: 0,
        cantidadCortada: 0,
        timer: "",
        countDown: 30,
      }
    },
    methods:{
      async loadItems(autoload = false){
          axios.post("/uso", {seccion:"corteMaster"});
        try {
            /*Obtengo los sku de gestionar dia*/
            const responseCorteDia = await axios.get("/taller/master/corte/dia");
            const resCorteDia = responseCorteDia.data;
            
            const sku = resCorteDia.map(element => this.eliminarUltimoApartado(element.sku))            
            this.skuCorte = resCorteDia;            

            /*Obtengo las piezas (guia de corte) de esos skus*/
            const responsePieza = await axios.post("/taller/pieza/list", {list: [...new Set(sku)] });
            const resPieza = responsePieza.data;

            this.allPiezas = resPieza;
          
            /*Obtengo el estado de las piezas de ese pedido*/
            const skuPedido = this.skuCorte.flatMap(corte => {
              return this.allPiezas
                .filter(pieza => pieza.sku === this.eliminarUltimoApartado(corte.sku))
                .map(pieza => ({ idPedido: corte.idPedido, idPieza: pieza.id, color: corte.sku.split('-').pop() }));
            });

            const responsePiezaEstado = await axios.post("/taller/pieza/pedido/corte", {info: skuPedido });
            const resPiezaEstado = responsePiezaEstado.data;

            this.allPiezas = resPiezaEstado.map(pieza => {
              const finalizado = pieza.terminado > 0;
              return { ...pieza, finalizado };
            });

            this.allPiezas.sort((a, b) => Number(a.paso) - Number(b.paso));

            //Quito el color del articulo y quito los duplicados (para mostrar arriba, el color ira dentro de cada uno)
            const articuloSinDuplicar = [];

            this.skuCorte.forEach(articulo => {
              const skuSinUltimoApartado = this.eliminarUltimoApartado(articulo.sku);
              
              if (!articuloSinDuplicar.some(objeto => objeto.sku === skuSinUltimoApartado)) {
                const articuloSinDuplicado = { ...articulo, sku: skuSinUltimoApartado };
                articuloSinDuplicar.push(articuloSinDuplicado);
              }
            });

            this.listSku = articuloSinDuplicar.map(element => ({ sku: element.sku, titulo: element.titulo, variant: "outline-dark" }));
            this.skuSelect = this.listSku[0].sku;
            this.tituloSelect = this.listSku[0].titulo;

            this.obtenerColoresSku();

            /*Aqui filtro segun la categoria que este seleccionada*/
            this.filtrarPiezas();
            this.coloresBotones();

            this.listSku.forEach(item => {
              item.cantidad = this.skuCorte.reduce((total, articulo) => {
                if (articulo.sku.includes(item.sku)) {
                  return total + articulo.cantidad;
                }
                return total;
              }, 0);             
              
            });

        } catch (error) {
            console.log(error);
        }
      },
      filtrarPiezas(){      
        this.piezas = [];

        this.allPiezas.forEach(element => {
            if(element.categoria == this.categoriaActiva && element.color == this.colorSelect && element.sku == this.skuSelect)
            {
                //this.piezas.push(JSON.parse(JSON.stringify(element)));
                this.piezas.push(element);
            }
        });

        // Crear un objeto auxiliar para almacenar las combinaciones únicas de categoría, color y SKU
        let uniqueCombos = {};

        // Filtrar los elementos y almacenar las combinaciones únicas en el objeto auxiliar
        this.piezas.forEach(element => {
          const combo = `${element.categoria}-${element.color}-${element.sku}-${element.id}`;
          if (uniqueCombos[combo]) {
            uniqueCombos[combo].finalizado = uniqueCombos[combo].finalizado && element.finalizado;
          } else {
            uniqueCombos[combo] = element;
          }
        });

        // Crear un nuevo array con los elementos únicos
        this.piezas = Object.values(uniqueCombos);


        //Busco la cantidad total de esa combinacion
        this.piezas.forEach(pieza => {
           const cantidad  = this.skuCorte.reduce((total, articulo) => {
                if (articulo.sku === `${pieza.sku}-${pieza.color}`) {
                  return total + articulo.cantidad;
                }
                return total;
              }, 0);
            
            pieza.fabricar = cantidad * pieza.cantidad;

            const totalTerminado  = this.allPiezas.reduce((total, articulo) => {
                if (pieza.id == articulo.id && articulo.color === pieza.color) {
                  return total + articulo.terminado;
                }
                return total;
              }, 0);
            
            pieza.terminadoTotal = totalTerminado;

            if(pieza.terminadoTotal > 0)
              pieza.finalizado = true;
        });

      },
      obtenerColoresSku(){

        const coloresUnicos = new Set();
        this.coloresSku = [];

        this.allPiezas.forEach(pieza => {
          if (pieza.sku === this.skuSelect && !coloresUnicos.has(pieza.color)) {
            coloresUnicos.add(pieza.color);
            const cantidad = this.skuCorte.reduce((total, articulo) => {
              if (articulo.sku === `${pieza.sku}-${pieza.color}`) {
                return total + articulo.cantidad;
              }
              return total;
            }, 0);
            this.coloresSku.push({
              nombre: pieza.color,
              variant: 'outline-dark',
              cantidad,
              sku: pieza.sku,
              paso: "",
            });
          }
        });

        this.coloresSku.forEach(objeto => {
          const elementoFiltrado = this.skuCorte.find(elemento => elemento.sku === `${objeto.sku}-${objeto.nombre}`);
          if (elementoFiltrado) {
            objeto.paso = elementoFiltrado.paso;
          }
        });

        this.coloresSku.sort((a, b) => Number(a.paso) - Number(b.paso));

        this.colorSelect = this.coloresSku[0].nombre;

      },
      cambioCategoria(categoria)
      {
        this.categoriaActiva = categoria;
        this.filtrarPiezas();
        this.coloresBotones();
      },
      cambioColor(color){
        this.colorSelect = color;
        this.filtrarPiezas();
        this.coloresBotones();
      },
      cambioSku(data)
      {
        this.skuSelect = data.sku;
        this.tituloSelect = data.titulo;
        this.obtenerColoresSku();
        this.filtrarPiezas();
        this.coloresBotones();
      },
      coloresBotones()
      {
        ///Nombre productos
        this.listSku.forEach(item => {
          const allFinish = this.allPiezas
            .filter(pieza => item.sku === pieza.sku)
            .every(pieza => pieza.finalizado);

          if (allFinish) {
            item.variant = "success";
          }
          else if (this.allPiezas.some(pieza => item.sku === pieza.sku && pieza.finalizado)) {
            item.variant = "warning";
          }
          else {
            item.variant = "outline-dark";
          }
        });

        //Color producto seleccionado
        this.coloresSku.forEach(item => {
          const allFinish = this.allPiezas
            .filter(pieza => this.skuSelect === pieza.sku && pieza.color === item.nombre)
            .every(pieza => pieza.finalizado);

          if (allFinish) {
            item.variant = "success";
          }
          else if (this.allPiezas.some(pieza => this.skuSelect === pieza.sku && pieza.color === item.nombre && pieza.finalizado)) {
            item.variant = "warning";
          } else {
            item.variant = "outline-dark";
          }
        });

        //Categorias
        //Piel
        let allFinishPiel = this.allPiezas
          .filter(pieza => this.skuSelect === pieza.sku && pieza.color === this.colorSelect && pieza.categoria === "Piel")
          .every(pieza => pieza.finalizado);

        if (allFinishPiel) {
          this.pielButton = "success";
        } else if (this.allPiezas.some(pieza => this.skuSelect === pieza.sku && pieza.color === this.colorSelect && pieza.categoria === "Piel" && pieza.finalizado)) {
          this.pielButton = "warning";
        } else {
          this.pielButton = "outline-dark";
        }

        //Forros
        let allFinishForros = this.allPiezas
          .filter(pieza => this.skuSelect === pieza.sku && pieza.color === this.colorSelect && pieza.categoria === "Forros")
          .every(pieza => pieza.finalizado);

        if (allFinishForros) {
          this.forrosButton = "success";
        } else if (this.allPiezas.some(pieza => this.skuSelect === pieza.sku && pieza.color === this.colorSelect && pieza.categoria === "Forros" && pieza.finalizado)) {
          this.forrosButton = "warning";
        } else {
          this.forrosButton = "outline-dark";
        }

        //Refuerzos
        let allFinishRefuerzos = this.allPiezas
          .filter(pieza => this.skuSelect === pieza.sku && pieza.color === this.colorSelect && pieza.categoria === "Refuerzos")
          .every(pieza => pieza.finalizado);

        if (allFinishRefuerzos) {
          this.refuerzosButton = "success";
        } else if (this.allPiezas.some(pieza => this.skuSelect === pieza.sku && pieza.color === this.colorSelect && pieza.categoria === "Refuerzos" && pieza.finalizado)) {
          this.refuerzosButton = "warning";
        } else {
          this.refuerzosButton = "outline-dark";
        }

        this.cantidadActual = this.skuCorte.reduce((total, articulo) => {
          if (articulo.sku.includes(this.skuSelect)) {
            return total + articulo.cantidad;
          }
          return total;
        }, 0);
      },
      eliminarUltimoApartado(cadena) {
            const lastIndex = cadena.lastIndexOf("-");
            if (lastIndex !== -1) {
                return cadena.substring(0, lastIndex);
            }
            return cadena;
      },
      piezaFinalizada(data)
      {        
        data.finalizado = !data.finalizado;
        if(data.finalizado)
        {
          data.terminadoTotal = data.fabricar;
        }
        //data.terminado = data.pedido;
        const piezasUpdate = [];

        this.allPiezas.forEach(pieza => {
          if(pieza.id == data.id && pieza.color == data.color && pieza.sku == data.sku)
          {
            if(data.finalizado)
              pieza.terminado = pieza.pedido;
            else
              pieza.terminado = 0;

            pieza.finalizado = data.finalizado;

            piezasUpdate.push({id: pieza.idPiezaPedido, terminado: pieza.terminado});
          }
        });

        axios
            .put("/taller/pieza/corte", {data: piezasUpdate})
            .then(response => {
                return response.data;
            })
            .then(res => {
            });

        //console.log(data.id);
        this.filtrarPiezas();
        this.$refs.tableCorte.refresh();

        this.coloresBotones();
      },
      reportModal(data)
      {
        if(data==null)
        {
          this.piezaReport = {troquel: this.tituloSelect};
          this.cantidadObjetivo = 0;
          this.cantidadCortada = 0;
          this.reportTipo = 1;
        }
        else{
          this.piezaReport = data;
          this.cantidadObjetivo = data.fabricar;
          this.cantidadCortada = data.fabricar;
          this.reportTipo = 0;
        }

        this.$refs['modal-report'].show();
      },
      guardarReporte()
      {
        const fechaActual = new Date();
        const dia = fechaActual.getDate().toString().padStart(2, '0');
        const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
        const anio = fechaActual.getFullYear().toString();

        let pedido = this.allPiezas.find(element => element.sku === this.skuSelect && element.color === this.colorSelect);
        let idPedido = pedido ? pedido.idPedido : null;

        let categoria = this.piezaReport.troquel ? this.piezaReport.troquel : "";

        let dataReport = {
          descripcion: this.descripcionReport, 
          categoria: categoria,
          sku: this.skuSelect,
          color: this.colorSelect,
          idPedido: idPedido,
          fecha: `${dia}-${mes}-${anio}`,
          seccion: 'Corte'
        }

        axios
          .post("/taller/pieza/reporte", dataReport)
          .then(response => {
              return response.data;
          })
          .then(res => {
                this.$swal({
                          icon: 'success',
                          title: 'Report creado',
                          text: 'El problema se ha guardado correctamente.',
                          customClass: {
                          confirmButton: 'btn btn-success',
                          },
                      })
          });

        if(this.reportTipo == 2)
        {          
          let resto = this.piezaReport.fabricar - this.cantidadCortada;
            const piezasUpdate = [];

            this.allPiezas.forEach(pieza => {
              
              if (pieza.id === this.piezaReport.id && pieza.color === this.piezaReport.color && pieza.sku === this.piezaReport.sku) {
                if (pieza.pedido > resto) {
                  pieza.terminado = pieza.pedido - resto;
                  resto = 0;
                } else {
                  pieza.terminado = Math.max(pieza.pedido - resto, 0);
                  resto -= pieza.terminado;
                  if(resto < 0)
                    resto = 0;
                }

                pieza.finalizado = true;

                piezasUpdate.push({ id: pieza.idPiezaPedido, terminado: pieza.terminado });
              }
            });            

          axios
              .put("/taller/pieza/corte", {data: piezasUpdate})
              .then(response => {
                  return response.data;
              })
              .then(res => {
              });

          this.piezaReport.terminadoTotal = this.cantidadCortada;
          this.$refs.tableCorte.refresh();

          this.coloresBotones();
        }

        this.$refs['modal-report'].hide();

      },
      seleccionarTipoReport(data)
      {
        this.reportTipo = data;

        if(this.reportTipo == 1 || this.reportTipo == 2)
        {
          setTimeout(()=>{this.$refs.descripcionReportInput.focus(); }, 300);
        }

      }
    },
    mounted() {
      this.loadItems();
    },
    beforeDestroy() {
      //clearInterval(this.timer);
    },
    created(){

      /*this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown -= 1;
        } else {
            this.loadItems(true);
            this.countDown = 30;
        }
      }, 1000);*/

    }
  }
</script>

<style lang="scss">
  @import '../@core/scss/vue/libs/vue-select.scss';

  .btn-circle{
    border-radius: 20px;
    padding: 12px;
    margin-right: 10px;
  }

  .btn-options{
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .div-imagenes{
    background-color: rgba(124, 255, 130, 0.35);
    border-radius: 15px;
  }

  .option-select{
    /*border: 2px solid #000000 !important;*/
    font-weight: bold; 
    font-size: 16px;
    /*box-shadow: 1px 1px 1px 2px rgba(255,255,255,1);*/
    //border: 2px solid #ffffff81 !important;
    box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    -webkit-box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    -moz-box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    //border-style: dotted !important;
  }

  .div-reporte{
    text-align: center;
    padding: 20px; 
    border-radius: 5px;
    border: 1px solid black;
  }

  .dark-layout .div-reporte{
    border: 1px solid white;
  } 

  .spinDisable button{
    display: none;
  }

  .div-imagenes-incompleta{
    background-color: rgba(255, 187, 78, 0.48);
    border-radius: 15px;
  }
</style>